<template>
    <div>
        <div class="container body-card-border-primary margin-top">
            <div class="row mt-2" v-if="userData?.data">
                <div class="">
                    <div class="body-card-border-primary container">
                        <div class="row">
                            <div class="col-sm-1 col-3">
                                <b-icon class="person-icon-border" font-scale="4" icon="person" />
                            </div>

                            <div class="col-sm-11 col-9">
                                <div>
                                    <label> {{ userData.data.fullName }} </label>
                                </div>

                                <div>
                                    <label class="text-normal text-muted small margin-bottom">{{ userData.data.email }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <!-- Menu list section -->
                <div class="col-sm-3 margin-bottom">
                    <div class="body-card-border-primary">
                        <div 
                            class="row pt-1 padding-top pointer" 
                            v-for="itemMenu in itemsMenuList" 
                            :key="itemMenu.index"
                            :class="{ 'item-menu-selected': selectedIndex === itemMenu.id }" 
                            @click="selectItemMenu(itemMenu.id, itemMenu.link)">
                            <div
                                class="col-2 pointer"
                                :class="{ 'text-color-white': selectedIndex === itemMenu.id }">
                                <b-icon class="icon-border-white h2" :icon="iconMappings[itemMenu.icon]" />
                            </div>

                            <div class="col-10 pointer">
                                <label 
                                    class="pointer"
                                    :class="{ 'text-color-white': selectedIndex === itemMenu.id }"> 
                                    {{ itemMenu.title }} 
                                </label>

                                <label 
                                    class="m-0 text-normal small margin-bottom pointer"
                                    :class="{ 'text-color-white': selectedIndex === itemMenu.id }">
                                    {{ itemMenu.description }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-9" v-if="userData">
                    <!-- My data section -->
                    <div v-if="sectionVisibility.MyData">
                        <MyData />
                    </div>

                    <div v-if="sectionVisibility.MySubscription">
                        <InConstrunction />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import "@/assets/style.css"
import SectionInfo from '@/components/Warnings/SectionInfo.vue'
import MyData from '@/views/MyProfile/MyData.vue'
import MySubscription from '@/views/MyProfile/MySubscription.vue'
import InConstrunction from '@/components/Misc/InConstruction.vue'
// import { DOCUMENT_TYPES } from '@/enums/enums';

export default {
    components: {
        SectionInfo,
        MyData,
        MySubscription,
        InConstrunction
    },

    data() {
        return {
            orders : null,
            email: "facu.espilocin@hotmail.com",
            selectedIndex: 0,
            itemsMenuList: [
                {
                    id: 0,
                    title: "Información personal",
                    description: "Consultá tus datos personales",
                    icon: "person",
                    link: "MyData"
                },
                {
                    id: 1,
                    title: "Suscripción",
                    description: "Consultá tu suscripción",
                    icon: "subscription",
                    link: "MySubscription"
                },
            ],

            iconMappings: {
                person: "person",
                cart: "cart4",
                subscription: "credit-card",
                pin: "pin-map"
            },

            sectionVisibility: {
                MyData: true,
                MySubscription: false
            },
        }
    },

    async created() { 
        // await this.$store.dispatch('getOrderDetails', localStorage.getItem("orderId") || 0);
        await this.$store.dispatch('getUserData', localStorage.getItem("tokenJWT") || null);
    },

    methods: {
        ellipsis(name) {
            return name.length > 29 ? name.substring(0, 29) + "..." : name
        },

        selectItemMenu(index, link) {
            this.selectedIndex = index;
            this.goToItemMenuDetails(link);
        },

        goToItemMenuDetails(link) {
            this.handleView(link);
        },

        handleView(link) {
            for (let section in this.sectionVisibility) {
                this.sectionVisibility[section] = false;
            }

            this.sectionVisibility[link] = true;
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    },

    computed: { 
        ...mapGetters(['getUserData']),

        userData() {
            return this.getUserData;
        },
    },

    watch: { }
}
</script>